<template>
    <div class="flex items-center justify-between">
        <div class="text-lg" :class="dueIcon(toNumber(params.display), toNumber(params.balance))"/>
        <div>
            {{ dueText(toNumber(params.display), toNumber(params.balance)) }}
        </div>
    </div>
</template>

<script setup lang="ts">

import {toNumber} from 'lodash'

defineProps({
    params: {
        required: true, type: Object as () => {
            display: number,
            balance: number
        }
    }
})

const dueText = ((dueDays: number, balance: number) => {
    if (balance === 0) {
        return 'Betalt'
    } else if (dueDays < 0) {
        return dueDays + ' dager siden!'
    } else if (dueDays === 0) {
        return 'I dag'
    } else {
        return 'Om ' + dueDays + ' dager'
    }
})

const dueIcon = ((dueDays: number, balance: number) => {
    if (balance === 0)
        return 'i-ph-check-circle'
    else if (dueDays < 0)
        return 'i-ph-warning text-error'
    else return 'i-ph-clock text-base-content/60'
})

</script>

<style scoped>

</style>